var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "paymentplan card active", class: _vm.colorClass },
    [
      _c("div", { staticClass: "circular header" }, [
        _vm.activeSubscription.is_free
          ? _c("h1", { staticClass: "price" }, [
              _vm._v("\n\t\t\t\t" + _vm._s(_vm.formatPrice(0, 2)) + "\n\t\t\t")
            ])
          : _c("h1", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.formatPrice(_vm.displayPrice, 2)) +
                  "\n      "
              )
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "currency bubble" }, [
          _vm._v(_vm._s(_vm.activeSubscription.pricing.currency))
        ])
      ]),
      _vm._v(" "),
      !_vm.activeSubscription.is_free
        ? _c("div", { staticClass: "interval" }, [
            _c("h1", { staticClass: "header" }, [_vm._v(_vm._s(_vm.interval))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.finalWaterPeriodPayment && _vm.finalWaterPeriodPayment.period
        ? _c("div", { staticClass: "period-price" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(
                  _vm.$t("pages.dashboard.subscriptions.final_period_price", {
                    start: _vm.finalWaterPeriodPayment.period.start_date,
                    end: _vm.finalWaterPeriodPayment.period.end_date
                  })
                ) +
                "\n\t\t"
            )
          ])
        : _vm.waterPeriodPrice && _vm.waterPeriodPrice.period
        ? _c("div", { staticClass: "period-price" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(
                  _vm.$t("pages.dashboard.subscriptions.period_price", {
                    start: _vm.waterPeriodPrice.period.start_date,
                    end: _vm.waterPeriodPrice.period.end_date
                  })
                ) +
                "\n\t\t\t"
            ),
            _vm.waterPeriodPrice.is_manually_adjusted
              ? _c("span", [
                  _vm._v(
                    "\n\t\t\t\t(" +
                      _vm._s(
                        _vm.$t(
                          "pages.dashboard.subscriptions.manually_adjusted"
                        )
                      ) +
                      ")\n\t\t\t"
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.changeable
        ? _c("div", { staticClass: "ui blue button" }, [
            _vm._v(_vm._s(_vm.$t("globals.buttons.change")))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4357293a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4357293a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/ActivePaymentPlan.vue
// module id = xiYh
// module chunks = 1